import React from "react";
import Chart from "react-apexcharts";

const OpenQueriesbyAgingBucket = ({ data = {} }) => {
  const series = [
    {
      name: "Queries",
      data: [
        data?.days0to2 || 35,
        data?.days3to5 || 37,
        data?.days6to10 || 39,
        data?.days11to15 || 19,
        data?.days16to30 || 37,
        data?.days30plus || 75,
      ],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
        distributed: true,
        barHeight: "70%",
      },
    },

    colors: [
      "#8BB6E8", // 0-2 days
      "#5C97E5", // 3-5 days
      "#F4BC1C", // 6-10 days
      "#F8A305", // 11-15 days
      "#F26D6D", // 16-30 days
      "#E82222", // >30 days
    ],

    xaxis: {
      categories: [
        "0–2 days",
        "3–5 days",
        "6–10 days",
        "11–15 days",
        "16–30 days",
        ">30 days",
      ],
      max: 80,
    },

    grid: {
      borderColor: "#e5e7eb",
      strokeDashArray: 0,
    },

    yaxis: {
      labels: {
        style: {
          fontSize: 12,
        },
      },
    },

    tooltip: {
      y: {
        formatter: (value) => `${value} queries`,
      },
    },
  };

  return (
    <>
      <Chart options={options} series={series} type="bar" height={250} />
    </>
  );
};

export default OpenQueriesbyAgingBucket;
